import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ConstantsKey } from 'app/shared/constant/constants-keys';

@Component({
  selector: '[core-menu-horizontal-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuHorizontalItemComponent implements OnInit {
  @Input()
  item: any;
  isTravelInsuranceVisible: boolean = false;

  ngOnInit() { 
    let configData:any = localStorage.getItem(ConstantsKey.CONFIG_CORE_DATA);
    if(configData) {
      configData = JSON.parse(configData);
      configData = configData.filter(data => data.key == 'buy_travel_insurance');
      if(configData.length == 1) {
        this.isTravelInsuranceVisible = (configData)[0].value;
      }
    }
  }

}
